module.exports = __webpack_public_path__ + "img/Guangxi-speed.a03fdf9e.png";